import { MainLayout } from 'shared/ui/layout/main';

import { Tabs } from './tabs';

export function OwnerLayout() {
  return <MainLayout tabs={<Tabs />} />;
}
